export default "__VITE_ASSET__Crck9LWU__"